import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';

const root = createRoot(document.getElementById('root')!);

async function start() {
  // authConfig throws if the tenant settings are missing, so it is imported
  // lazily and the failure is rendered rather than left as a blank page.
  const { msalInstance } = await import('./authConfig');
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();

  const { App } = await import('./App');
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

start().catch((err: unknown) => {
  root.render(
    <div className="page">
      <div className="alert error">
        <strong>This app is not configured.</strong>
        <p>{err instanceof Error ? err.message : String(err)}</p>
      </div>
    </div>,
  );
});
